import { ClientDeletionProvider } from "../contexts/ClientDeletion/ClientDeletionProvider";
import useClientDeletion from "../hooks/useClientDeletion";

import { DeleteConfirm } from "@/components/ui/v2/delete-confirm";
import { useAuthState } from "@/features/auth/api";

export const DeleteClientConfirm = ({
  clientId,
  name,
  open,
  onOpenChange,
}: {
  clientId: string;
  name: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const { tenantId } = useAuthState();

  const handleCompleted = () => {
    onOpenChange(false);
  };

  return (
    <ClientDeletionProvider
      onDeleteSuccess={handleCompleted}
      onDeleteError={handleCompleted}
    >
      <DeleteClientConfirmInner
        clientId={clientId}
        name={name}
        tenantId={tenantId ?? ""}
        open={open}
        onOpenChange={onOpenChange}
      />
    </ClientDeletionProvider>
  );
};

const DeleteClientConfirmInner = ({
  clientId,
  name,
  tenantId,
  open,
  onOpenChange,
}: {
  clientId: string;
  name: string;
  tenantId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const { deletingClient, deleteClient } = useClientDeletion();

  const handleDelete = () => {
    deleteClient({ clientId, tenantId });
  };

  return (
    <DeleteConfirm
      open={open}
      onOpenChange={onOpenChange}
      onDelete={handleDelete}
      isLoading={deletingClient}
      name={name}
      entityType="client"
    />
  );
};
